export default "__VITE_ASSET__a1cda3c4__"